import WhatIsMentalNoiseSection from "./WhatIsMentalNoiseSection.js";
import SourcesOfMentalNoiseSection from "./SourcesOfMentalNoiseSection.js";
import InternalVsExternalSection from "./InternalVsExternalSection.js";
import MentalNoiseVsOverthinkingSection from "./MentalNoiseVsOverthinkingSection.js";
import MentalNoiseAndAnxietySection from "./MentalNoiseAndAnxietySection.js";
import WhyYourBrainWontLetGoSection from "./WhyYourBrainWontLetGoSection.js";
import MentalNoiseBeforeSleepSection from "./MentalNoiseBeforeSleepSection.js";
import ReducingMentalNoiseSection from "./ReducingMentalNoiseSection.js";

const SECTION_COMPONENTS = {
  "what-is-mental-noise": WhatIsMentalNoiseSection,
  "sources-of-mental-noise": SourcesOfMentalNoiseSection,
  "internal-vs-external": InternalVsExternalSection,
  "mental-noise-vs-overthinking": MentalNoiseVsOverthinkingSection,
  "mental-noise-and-anxiety": MentalNoiseAndAnxietySection,
  "why-your-brain-wont-let-go": WhyYourBrainWontLetGoSection,
  "mental-noise-before-sleep": MentalNoiseBeforeSleepSection,
  "reducing-mental-noise": ReducingMentalNoiseSection,
};

export default SECTION_COMPONENTS;
